module.exports = __webpack_public_path__ + "media/common/fonts/streamline-large/streamline-large-4e94e2e1851cadb2ea75cc01e5b08c2f.svg";